import { useCallback } from 'react';
import type { JiraNavigationItemTypeKey } from '@atlassian/jira-relay/src/__generated__/simpleNavigationTab_businessTabs.graphql';
import { NOT_APPLICABLE } from '@atlassian/jira-router-resources-business-navigation/src/constants.tsx';
import { useNavigationResource } from '@atlassian/jira-router-resources-business-navigation/src/index.tsx';

export const useUpdateNavigationDefaultView = (projectKey: string) => {
	const { data: navigationData, update } = useNavigationResource();

	return useCallback(
		(defaultView: JiraNavigationItemTypeKey) => {
			if (navigationData == null || navigationData === NOT_APPLICABLE) {
				return;
			}

			const favorites = navigationData?.favorites?.map((favourite) => {
				if (favourite.key === projectKey) {
					return {
						...favourite,
						defaultView: defaultView.toLowerCase(),
					};
				}
				return favourite;
			});

			const recents = navigationData?.recents?.map((recent) => {
				if (recent.key === projectKey) {
					return {
						...recent,
						defaultView: defaultView.toLowerCase(),
					};
				}
				return recent;
			});

			update(() => ({
				...navigationData,
				recents,
				favorites,
			}));
		},
		[navigationData, update, projectKey],
	);
};
